const DEVICE_ID_KEY = 'provisium.market.device_id'

const generateDeviceId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

export const getOrCreateDeviceId = (): string => {
  const existing = localStorage.getItem(DEVICE_ID_KEY)
  if (existing && existing.length >= 8) {
    return existing
  }
  const next = generateDeviceId()
  localStorage.setItem(DEVICE_ID_KEY, next)
  return next
}

export const buildDeviceLabel = (): string => {
  if (typeof navigator === 'undefined') {
    return 'Browser'
  }
  const ua = navigator.userAgent
  if (/iPhone|iPad/i.test(ua)) {
    return 'Safari · iOS'
  }
  if (/Android/i.test(ua)) {
    return 'Chrome · Android'
  }
  if (/Mac OS X/i.test(ua)) {
    return 'Браузер · macOS'
  }
  if (/Windows/i.test(ua)) {
    return 'Браузер · Windows'
  }
  return 'Браузер'
}
